import type { BaseEmoji } from 'emoji-mart';

export const customReactions: BaseEmoji[] = [
    {
        colons: ':fire:',
        emoticons: [],
        id: 'fire',
        name: 'Fire',
        native: '🔥',
        skin: null,
        unified: '1f525',
    },
    {
        colons: ':+1:',
        emoticons: [],
        id: '+1',
        name: 'Thumbs Up Sign',
        native: '👍',
        skin: null,
        unified: '1f44d',
    },
    {
        colons: ':clap:',
        emoticons: [],
        id: 'clap',
        name: 'Clapping Hands Sign',
        native: '👏',
        skin: null,
        unified: '1f44f',
    },
    {
        colons: ':hearts:',
        emoticons: [],
        id: 'hearts',
        name: 'Black Heart Suit',
        native: '♥️',
        skin: null,
        unified: '2665-fe0f',
    },
    {
        colons: ':joy:',
        emoticons: [],
        id: 'joy',
        name: 'Face with Tears of Joy',
        native: '😂',
        skin: null,
        unified: '1f602',
    },
];

const initReactionUsersMap = () => {
    const map = {};
    customReactions.forEach(reaction => {
        map[reaction.id] = [];
    });
    return map;
};

export const getUsersByReaction = async (channel, messageId) => {
    const response = await channel.getReactions(messageId, { limit: 100 });
    const reactions = response.reactions;

    const result = initReactionUsersMap();
    reactions.forEach(reaction => {
        const reactionId = reaction.type;
        result[reactionId].push(reaction.user);
    });

    return result;
};
